























































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../util/constants';
import { ServiceRequest, RequestStatus } from '@/types/entity';
import { DateUtils } from '@/util/dateUtils';
import { ObjectFactory } from '@/config/objectFactory';
import ServiceRequestDetails from './ServiceRequestDetails.vue';
import { CommonUtils } from '@/util/commonUtils';
import RequestMobile from '../components/RequestMobile.vue';
import { MemberLocation, MemberProfile } from '@/types/response';
import { GetServiceRequestsInput } from '@/types/request';
@Component({
    components: {
        ServiceRequestDetails,
        RequestMobile,
    },
    watch: {
        '$route.query.requestType'() {
            const requestPanel = this as RequestPanel;
            requestPanel.init();
        },
        '$route.query.status'() {
            const requestPanel = this as RequestPanel;
            requestPanel.init();
        },
        '$route.path'(to, from) {
            if (!this.$route.params.id && !to.includes('new-service-request') && !to.includes('upload-request')) {
                const requestPanel = this as RequestPanel;
                requestPanel.init();
            } else if (from.includes(MedTransGoConstants.URL_RESCHEDULE_REQUEST) ||
                from.includes(MedTransGoConstants.URL_EDITSERVICEDETAILS_REQUEST)) {
                const requestPanel = this as RequestPanel;
                requestPanel.init();
            }
        },
    },
})
export default class RequestPanel extends Vue {
    private requiresApprovalRequests: ServiceRequest[] = [];
    private pendingRequests: ServiceRequest[] = [];
    private completedRequests: ServiceRequest[] = [];
    private confirmedRequests: ServiceRequest[] = [];
    private canceledRequests: ServiceRequest[] = [];
    private selectRequestId: string | undefined = '';
    private requestType: any = 'transportRequest';
    private DateUtils = DateUtils;
    private showRequestPanel = false;
    private showNoRequests = false;
    private loading = true;
    private fullname: string = '';
    private memberProfile: MemberProfile = {} as any;
    private blurRequestDetails = false;
    public mounted() {
        this.fullname = ObjectFactory.getCacheService().getSessionInfo().fullname;
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        if (this.memberProfile.isRestrictedView !== undefined && this.memberProfile.isRestrictedView) {
            this.blurRequestDetails = true;
        }
        this.init();
    }

    private async init() {
        this.loading = true;
        const requestType = this.$route.query.requestType;
        this.requestType = requestType ? requestType : 'transportRequest';
        const status = this.$route.query.status;
        this.selectRequestId = this.$route.params.id;
        this.confirmedRequests = [];
        this.requiresApprovalRequests = [];
        this.pendingRequests = [];
        this.completedRequests = [];
        this.canceledRequests = [];

        if (status) {
            await this.getRequests(status as any, 15);
            this.checkNoRequest();
        } else {
            await this.getRequests('Requires Approval', 5);
            await this.getRequests('Pending', 5);
            await this.getRequests('Confirmed', 5);
            await this.getRequests('Completed', 5);
            await this.getRequests('Canceled', 5);
            this.checkNoRequest();
        }
        if (this.$route.query && this.$route.query.patientId && !this.$route.path.includes('new-service-request')) {
            this.$router.push({ path: '/new-service-request/service-visit', append: true, query: this.$route.query});
        }
        this.loading = false;
    }
    private menuClick() {
            const element = document.getElementById('newId');
            if (element) {
            element.classList.add('leftDroAdd');
        }
    }

    private menuRemove() {
            const element = document.getElementById('newId');
            if (element) {
            element.classList.remove('leftDroAdd');
        }
    }
    private async getRequests(status: RequestStatus, limit?: number ) {
        const locations: string[] = [];
        if (this.memberProfile.managedLocations) {
            this.memberProfile.managedLocations.forEach((location) => {
                locations.push(location.id);
            });
        }
        const getRequests: GetServiceRequestsInput = {
            baseURL: this.$store.state.serverUrl,
            conditions: [],
            status,
            service: this.requestType,
            limit,
        };
        if (status === 'Pending' && getRequests.conditions) {
            getRequests.conditions.push({
                op: 'gt',
                fieldName: 'appointment.timestamp',
                value: DateUtils.getCurrentTimeInMillis() - DateUtils.convertMinutesToMillis(24 * 60),
            });
        }
        if (locations && getRequests.conditions && this.memberProfile.memberType === 'ORG_MANAGER') {
            getRequests.conditions.push({
                op: 'in',
                fieldName: 'locationId',
                value: locations,
            });
        }
        const response = await ObjectFactory.getRequestService().getRequests(getRequests, false);
        switch (status) {
            case 'Requires Approval':
                this.requiresApprovalRequests = response.data as any;
                if ((!this.selectRequestId && !CommonUtils.isEmpty(this.requiresApprovalRequests))) {
                    this.selectRequestId = this.requiresApprovalRequests[0].id;
                    this.$data.transporterRequest = this.requiresApprovalRequests[0].transportRequest;
                    this.showRequestDetails(this.selectRequestId);
                }
                break;
            case 'Pending':
                this.pendingRequests = response.data as any;
                if ((!this.selectRequestId && !CommonUtils.isEmpty(this.pendingRequests))) {
                    this.selectRequestId = this.pendingRequests[0].id;
                    this.$data.transporterRequest = this.pendingRequests[0].transportRequest;
                    this.showRequestDetails(this.selectRequestId);
                }
                break;
            case 'Confirmed':
                this.confirmedRequests = response.data as any;
                if ((!this.selectRequestId && !CommonUtils.isEmpty(this.confirmedRequests))) {
                    this.selectRequestId = this.confirmedRequests[0].id;
                    this.showRequestDetails(this.selectRequestId);
                }
                if (this.pendingRequests && this.pendingRequests.length) {
                    for (let index = 0; index < this.pendingRequests.length; index++) {
                        const element = this.pendingRequests[index];
                        if (element.transportRequest && element.transportRequest.rideshareService) {
                            const rideshareRequest = this.pendingRequests.splice(index, 1);
                            rideshareRequest[0].status = 'Confirmed';
                            if (!this.confirmedRequests) {
                                this.confirmedRequests = [];
                            }
                            this.confirmedRequests.push(rideshareRequest[0]);
                        }
                    }
                }
                break;
            case 'Completed':
                this.completedRequests = response.data as any;
                if ((!this.selectRequestId && !CommonUtils.isEmpty(this.completedRequests))) {
                    this.selectRequestId = this.completedRequests[0].id;
                    this.showRequestDetails(this.selectRequestId);
                }
                break;
            case 'Canceled':
                this.canceledRequests = response.data as any;
                if ((!this.selectRequestId && !CommonUtils.isEmpty(this.canceledRequests))) {
                    this.selectRequestId = this.canceledRequests[0].id;
                    this.showRequestDetails(this.selectRequestId);
                }
                break;
        }
    }
    private showRequestDetails(id: string | undefined) {
        if (!this.$route.params.id || id !== this.$route.params.id) {
            this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}/${id}`, query: this.$route.query });
        }
    }

    private checkNoRequest() {
        this.showRequestPanel = !CommonUtils.isEmpty(this.requiresApprovalRequests)
            || !CommonUtils.isEmpty(this.pendingRequests)
            || !CommonUtils.isEmpty(this.canceledRequests) ||
            !CommonUtils.isEmpty(this.confirmedRequests) || !CommonUtils.isEmpty(this.completedRequests);
        this.showNoRequests = !this.showRequestPanel;
    }
    private toggleMenu() {
        const leftBarElement = document.getElementById('leftBar');
        if (leftBarElement) {
            leftBarElement.classList.toggle('slidePanelDiv');
        }
        const element = document.getElementById('slidDash');
        if (element) {
            element.classList.toggle('slidDashMins');
        }
        const arrowIconelement = document.getElementById('ArrowIcon');
        if (arrowIconelement) {
            arrowIconelement.classList.toggle('slideAngleArrow-in');
        }
    }
}


